import {onFind} from "@elements/init-modules-in-scope";
import {on, findIn, closest} from "@elements/dom-utils";

export function init() {
    onFind(".js-collect-formdata-cart", function(button) {

        on("click", function(){
            let form = closest('form', button);
            let formData = new FormData(form);
            let paramString = '';

            for (let pair of formData.entries()) {
                let name = pair[0];
                let value = pair[1];
                paramString += '&'+name+'='+value;
                console.log(paramString);



                //create array of all form data
                //let data = {};
                //data[name] = value;
                //console.log(data);



            }

            button.setAttribute('data-content-url', button.getAttribute('data-content-url')+paramString);
        }, button)
    })
}
